






































import { defineComponent, computed } from "@vue/composition-api";
import { percentageOneDecimal } from "@/helpers/format-helper";
import dayjs from "dayjs";

export default defineComponent({
  name: "EntryPvTable",
  props: {
    data: {
      type: Array,
      default: () => [{ date: "", totalEntry: 0, totalPv: 0 }]
    },
    categoryData: {
      type: Array,
      default: () => [{ date: "", totalEntry: 0, totalPv: 0 }]
    },
    period: {
      type: String,
      default: ""
    },
    category: {
      type: Boolean,
      default: false
    },
    totalEntry: {
      type: Number,
      default: 0
    },
    totalPv: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const displayPeriod = computed(() => props.period);
    const displayCategory = computed(() => props.category);
    const sumEntry = computed(() => props.totalEntry);
    const sumPv = computed(() => props.totalPv);

    const tableData = computed(() => {
      if (!props.data) {
        return [];
      }
      const data = props.data.map(e => {
        const el = e as { date: string; totalPv: number; totalEntry: number };
        const date = dayjs(el.date).format("YYYYMMDD");
        const endDate = dayjs(el.date)
          .endOf("isoWeek")
          .format("YYYYMMDD");
        return {
          date:
            displayPeriod.value === "week"
              ? `${date.substring(0, 4)}/${date.substring(
                  4,
                  6
                )}/${date.substring(6, 8)} 〜 ${endDate.substring(
                  0,
                  4
                )}/${endDate.substring(4, 6)}/${endDate.substring(6, 8)}`
              : `${date.substring(0, 4)}/${date.substring(4, 6)}`,
          totalPv: el.totalPv,
          totalEntry: el.totalEntry,
          entryRate: percentageOneDecimal(el.totalEntry, el.totalPv)
        };
      });
      return data;
    });

    const sumRate = computed(() => {
      return percentageOneDecimal(props.totalEntry, props.totalPv);
    });

    const sumCategory = computed(() => {
      const result = props.categoryData.reduce(
        (acc: any, cur: any) => {
          acc.pv += cur.totalPv;
          acc.entry += cur.totalEntry;
          return acc;
        },
        { pv: 0, entry: 0 }
      ) as {
        rate: number;
        pv: number;
        entry: number;
      };

      result["rate"] = percentageOneDecimal(result.entry, result.pv) || 0;
      result["pv"] = result.pv;
      result["entry"] = result.entry;

      return result;
    });

    return {
      tableData,
      sumPv,
      sumEntry,
      sumRate,
      sumCategory,
      displayPeriod,
      displayCategory
    };
  }
});
